import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Person } from '../../models/person';
import { faUser,faPlus } from '@fortawesome/pro-regular-svg-icons';

@Component({
  standalone: false,
  selector: 'app-modal-choose-rider',
  templateUrl: './modal-choose-rider.component.html',
styleUrls:  ['./modal-choose-rider.component.css']
})
export class ModalChooseRiderComponent implements OnInit {

  faUser = faUser;
  faPlus = faPlus;
  rider_list: Person[] = [];
  rider_selected$: EventEmitter<Person> = new EventEmitter<Person>();
  add_rider$: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }

  handleSelectPerson(person: Person){
  	this.rider_selected$.emit(person);
  }

  handleAddNew(){
  	this.add_rider$.emit(true);
  }

}
